import { FragmentId, RecordId } from '../../core/public_api';
import { Comparable, Trackable } from '../../helpers/public_api';
import { UploadStatus } from './upload-status.entity';

export interface IUploadItem {
    tempId: string;
    id?: FragmentId | RecordId;
    name: string;
    type: UploadType;
    date?: Date;
    state: {
        progress: number;
        status: UploadStatus;
        message?: string;
    };
    parent?: {
        fragmentId: FragmentId;
    };
    group: string;
    lastProgressUpdate: Date;
    session?: {
        sessionId?: string;
        file: File;
    };
}

export enum UploadType {
    DIRECT = 'Direct',
    RESUMABLE = 'Resumable'
}

export class UploadItem implements IUploadItem, Comparable, Trackable {
    readonly tempId: string;
    id?: FragmentId | RecordId;
    name: string;
    type: UploadType;
    date?: Date;
    state: {
        progress: number;
        status: UploadStatus;
        message?: string;
    };

    parent?: {
        fragmentId: FragmentId;
    };

    session?: {
        sessionId?: string;
        file: File;
    };

    group: string;
    lastProgressUpdate: Date;

    constructor({ tempId, id, name, type, date, state, parent, group, lastProgressUpdate, session }: IUploadItem) {
        this.tempId = tempId;
        this.id = id;
        this.name = name;
        this.type = type;
        this.state = state;
        this.parent = parent;
        this.group = group;
        if (date) {
            this.date = new Date(date.toString());
        }
        this.lastProgressUpdate = lastProgressUpdate;
        this.session = session;
    }

    equals(other: any): boolean {
        if (!(other instanceof UploadItem)) {
            return false;
        }
        return this.tempId === other.tempId;
    }

    trackBy(): string {
        return this.tempId + this.state.progress;
    }
}
